import { getDecorations } from '../decorations/plugin';
import { updateDecorations } from './decoration';
export var updatePluginStateDecorations = function updatePluginStateDecorations(state, decorations, key) {
  return updateDecorations(state.doc, getDecorations(state), decorations, key);
};